export const HISTORY_EVENTS = Object.freeze({
  HISTORY_PAGE_VIEWED: {
    name: 'history_page_viewed',
    category: 'History',
    description: 'History 页面进入时触发',
    requiredParams: [],
    optionalParams: [
      'event_label', 'module_name', 'source_position', 'element_type',
      'lang', 'is_logged_in', 'navigation_trigger'
    ]
  },
  HISTORY_SYNC_COMPLETED: {
    name: 'history_sync_completed',
    category: 'History',
    description: 'History 列表同步、缓存恢复或失败后触发',
    requiredParams: ['action_status'],
    optionalParams: [
      'event_label', 'module_name', 'source_position', 'service', 'operation_type',
      'reason_code', 'http_status', 'duration_ms', 'request_id',
      'history_sync_source', 'history_cache_status', 'history_group_count',
      'history_item_count', 'history_reference_count', 'history_has_more'
    ]
  },
  HISTORY_CONTENT_VIEWED: {
    name: 'history_content_viewed',
    category: 'History',
    description: 'History skeleton、空态或列表内容首次稳定展示时触发',
    requiredParams: ['history_content_state'],
    optionalParams: [
      'event_label', 'module_name', 'source_position', 'element_type',
      'action_status', 'reason_code', 'history_group_count', 'history_item_count',
      'history_visible_count', 'history_filtered_count', 'history_reference_count',
      'history_has_more', 'history_filter_type'
    ]
  },
  HISTORY_FILTER_CHANGED: {
    name: 'history_filter_changed',
    category: 'History',
    description: 'History 日期筛选条件变化时触发',
    requiredParams: ['history_filter_type'],
    optionalParams: [
      'event_label', 'module_name', 'source_position', 'element_name', 'element_type',
      'method', 'option_value', 'history_group_count', 'history_item_count',
      'history_filtered_count', 'history_visible_count'
    ]
  },
  HISTORY_LOAD_MORE_COMPLETED: {
    name: 'history_load_more_completed',
    category: 'History',
    description: 'History 加载更多列表项完成、失败或跳过时触发',
    requiredParams: ['action_status'],
    optionalParams: [
      'event_label', 'module_name', 'source_position', 'element_name', 'element_type',
      'method', 'reason_code', 'history_group_count', 'history_visible_count',
      'history_has_more', 'duration_ms'
    ]
  },
  HISTORY_BACK_TO_TOP_CLICKED: {
    name: 'history_back_to_top_clicked',
    category: 'History',
    description: '用户点击 History 页面 Top / Back to top 按钮时触发',
    requiredParams: [],
    optionalParams: [
      'event_label', 'module_name', 'source_position', 'element_name', 'element_type',
      'method', 'scroll_depth_px', 'history_group_count', 'history_visible_count',
      'history_has_more'
    ]
  },
  HISTORY_UPLOAD_CLICKED: {
    name: 'history_upload_clicked',
    category: 'History',
    description: '用户点击 History 页面右下角悬浮「上传照片」按钮时触发',
    requiredParams: [],
    optionalParams: [
      'event_label', 'module_name', 'source_position', 'element_name', 'element_type',
      'method', 'scroll_depth_px', 'history_group_count', 'history_visible_count',
      'history_has_more', 'collapsed_state'
    ]
  },
  HISTORY_CARD_OPENED: {
    name: 'history_card_opened',
    category: 'History',
    description: '用户从 History 点击 solo card 或 reference thumb 准备打开 Result 时触发',
    requiredParams: ['history_entry_type'],
    optionalParams: [
      'event_label', 'module_name', 'source_position', 'element_name', 'element_type',
      'method', 'content_id', 'content_type', 'related_content_id', 'related_content_type',
      'subject_id', 'subject_present', 'is_legacy', 'history_reference_count'
    ]
  },
  HISTORY_RESULT_NAVIGATION_COMPLETED: {
    name: 'history_result_navigation_completed',
    category: 'History',
    description: 'History 打开 Result 的前置处理和路由跳转完成、失败或阻断时触发',
    requiredParams: ['action_status'],
    optionalParams: [
      'event_label', 'module_name', 'source_position', 'element_name', 'element_type',
      'method', 'reason_code', 'service', 'operation_type', 'duration_ms',
      'content_id', 'content_type', 'related_content_id', 'related_content_type',
      'subject_id', 'subject_present', 'is_legacy', 'history_entry_type',
      'scope_type', 'scope_key', 'http_status'
    ]
  },
  HISTORY_REFERENCE_CREATE_COMPLETED: {
    name: 'history_reference_create_completed',
    category: 'History',
    description: 'History 新建 reference 入口准备原图缓存、写入 re-entry draft 并跳转 Upload 完成、失败或阻断时触发',
    requiredParams: ['action_status'],
    optionalParams: [
      'event_label', 'module_name', 'source_position', 'element_name', 'element_type',
      'method', 'reason_code', 'operation_type', 'duration_ms',
      'content_id', 'content_type', 'subject_id', 'subject_present',
      'history_entry_type', 'history_group_id', 'target_route'
    ]
  },
  HISTORY_DELETE_DIALOG_OPENED: {
    name: 'history_delete_dialog_opened',
    category: 'History',
    description: 'History 删除确认弹窗展示时触发',
    requiredParams: [],
    optionalParams: [
      'event_label', 'module_name', 'source_position', 'element_name', 'element_type',
      'method', 'content_id', 'content_type', 'subject_id', 'is_legacy',
      'history_reference_count'
    ]
  },
  HISTORY_DELETE_COMPLETED: {
    name: 'history_delete_completed',
    category: 'History',
    description: 'History 删除确认、取消、成功、失败或 rollback 后触发',
    requiredParams: ['action_status'],
    optionalParams: [
      'event_label', 'module_name', 'source_position', 'element_name', 'element_type',
      'method', 'reason_code', 'duration_ms', 'http_status',
      'content_id', 'content_type', 'subject_id', 'is_legacy',
      'history_group_count', 'history_item_count', 'history_reference_count'
    ]
  },
  HISTORY_REFERENCE_THUMBNAIL_LOAD_COMPLETED: {
    name: 'history_reference_thumbnail_load_completed',
    category: 'History',
    description: 'History reference 缩略图缓存读取、网络加载成功、失败或缺失时触发',
    requiredParams: ['action_status'],
    optionalParams: [
      'event_label', 'module_name', 'source_position', 'element_name', 'element_type',
      'method', 'reason_code', 'duration_ms', 'content_id', 'content_type',
      'related_content_id', 'related_content_type'
    ]
  },
  HISTORY_SHEET_CLOSED: {
    name: 'history_sheet_closed',
    category: 'History',
    description: 'History 吸底动作面板（移动端点按卡片唤出）关闭时触发',
    requiredParams: [],
    optionalParams: [
      'event_label', 'module_name', 'source_position', 'element_name', 'element_type',
      'method', 'option_value', 'history_entry_type'
    ]
  }
});
